import * as React from "react";
import { PropTypes } from "components/controls";
import Label from "common/components/controls/Label";
import PU from "common/utils/PrestupyUtils";

export interface StavLabelProps {
    stav: number;
}

class StavLabel extends React.Component<StavLabelProps> {

    render() {

        const { stav } = this.props;
        let label: string;
        let color: PropTypes.Color = 'warning';
        switch (stav) {

            case PU.Stav_PotvrzeniIC:
                label = 'Potvrzení IČ';
                break;
            case PU.Stav_ZaplaceniPopl:
                label = 'Zaplacení SP';
                break;
            case PU.Stav_ZpracovaniPrestupu:
                label = 'Zpracování sekr.';
                break;
            case PU.Stav_PotvrzeniOdst:
                label = `Ods. - vyjádření KČ`;
                break;
            case PU.Stav_ZaplaceniOdst:
                label = `Ods. - platba`;
                break;
            case PU.Stav_Ukonceno:
                color = "success";
                label = 'Vyřízeno';
                break;
            case PU.Stav_ZamitnutoIC:
                color = "danger";
                label = 'Zamítnuto IČ.';
                break;
            case PU.Stav_Stornovan:
                color = "danger";
                label = 'Stornováno';
                break;
        }

        return <Label color={color} label={label} />;
    }
}




export default StavLabel;